import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { FormService } from 'path-shared/services/form/form.service';
import { Builder } from 'path-shared/models/builder';
import { GruaMotiusDesestimarService } from '../../services/grua-motius-desestimar.service';
import { MotiusDestimacioGrua } from 'app/sections/grua/Models/motius-desestimacio.model';

@Component({
  selector: 'app-grua-motius-desestimar-editor',
  templateUrl: './grua-motius-desestimar-editor.component.html',
  styleUrls: ['./grua-motius-desestimar-editor.component.scss']
})
export class GruaMotiusDesestimarEditorComponent implements OnInit {

  secure_id: string;
  gruaMotiusDesestimar: MotiusDestimacioGrua;
  dialogData: ComponentDialog;
  closeButtonText: string;

  @ViewChild('mainForm') private mainForm: ElementRef;

  constructor(
    private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private gruaMotiusDesestimarService: GruaMotiusDesestimarService,
    private i18n: I18n,
    private toastr: ToastrService,
    public thisDialogRef: MatDialogRef<GruaMotiusDesestimarEditorComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.gruaMotiusDesestimar = Builder.newMotiusDesestimacioGrua();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Tancar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
   }

  ngOnInit() {
    if (this.secure_id !== null) {
      this.gruaMotiusDesestimarService.getGruaMotiusDesestimar(this.secure_id).subscribe(data => {
        this.gruaMotiusDesestimar = data;
      });
    }
  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.gruaMotiusDesestimarService.setGruaMotiusDesestimar(this.gruaMotiusDesestimar).subscribe(result => {
        this.toastr.info(this.i18n('Motiu desestimació guardat correctament'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hi ha errors en el formulari!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Segur que vol esborrar el motiu de desestimació?'))
    .then((confirmed) => {
        if (confirmed) {
          this.gruaMotiusDesestimarService.removeGruaMotiusDesestimar(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('Motiu de desestimació esborrat correctament'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }

}
